import React from "react";
import ReactDOM from "react-dom/client";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "./Assets/css/style.scss";
import "./Assets/css/responsive.scss";
import App from "./App";
import { UnoStoreHooks, unoStore } from "@simulanisindia/ui";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from './Store/store';

const { UnoProvider } = UnoStoreHooks;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <UnoProvider store={unoStore}>
    <Provider store={store}>
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    </Provider>
  </UnoProvider>
);

